import useMe from "./useMe";
import roles from "../consts/roles";

const useEnabledDeleteCount = () => {
    const {role} = useMe();
    return role === roles.CEO || role === roles.ADMIN;
};

export default useEnabledDeleteCount;